// frontend/src/pages/forecastChartRows.js
//
// A stored forecast run → the rows ForecastChart plots. Lives outside the page
// so the contract it enforces can be tested without mounting the generator.
//
// The wire shape is one shape: `ForecastResult.forecast_json` carries `dates`
// (month keys, '%Y-%m' — forecast_engine/evaluation.py
// generate_forecast_dates) and `values`, written together by
// forecasting/services.py _save_forecast_outputs_batch.

/**
 * @param {object|null} result — a serialized ForecastResult.
 * @returns {Array<{date: string, value: number|null}>|null} — empty when
 *   there is nothing to draw, `null` when the stored forecast breaks the
 *   contract, so the chart says it cannot be displayed instead of "no data".
 *   A period the run produced no value for is `null`: zero is a forecast of
 *   no demand, a claim the run did not make.
 */
export function forecastChartRows(result) {
  const forecast = result?.forecast_json;
  if (!forecast) return [];

  const { dates, values } = forecast;
  if (!Array.isArray(dates) || !Array.isArray(values)) {
    console.error('ForecastGenerator: forecast_json carries no dates/values arrays', forecast);
    return null;
  }
  // Zipped by position, so a length disagreement is not a shorter chart — it
  // is every point after the first gap plotted against the wrong month.
  if (dates.length !== values.length) {
    console.error('ForecastGenerator: forecast_json dates and values disagree in length', {
      dates: dates.length, values: values.length,
    });
    return null;
  }

  return dates.map((date, idx) => ({ date, value: values[idx] ?? null }));
}

export default forecastChartRows;
